import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'


// **Import custom Bootstrap build**
import '@/assets/styles/custom-theme.scss'

// BootstrapVue
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)

// 1) Font Awesome core
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

// 2) All free icon packs
import { fas } from '@fortawesome/free-solid-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'
import { fab } from '@fortawesome/free-brands-svg-icons'

// 3) Add entire packs to the library
library.add(fas, far, fab)  // now every icon is registered :contentReference[oaicite:2]{index=2} :contentReference[oaicite:3]{index=3}

// 4) Register the <font-awesome-icon> component globally
Vue.component('font-awesome-icon', FontAwesomeIcon)




Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
